import { type FC } from 'react';

export const WhySgHeroRoutingIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M2.5 15.8334C2.5 17.2132 3.62021 18.3334 5 18.3334C6.37979 18.3334 7.5 17.2132 7.5 15.8334C7.5 14.4536 6.37979 13.3334 5 13.3334C3.62021 13.3334 2.5 14.4536 2.5 15.8334H2.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 15.8333H14.5833C16.1931 15.8333 17.5 14.5264 17.5 12.9166C17.5 11.3069 16.1931 9.99996 14.5833 9.99996H5.41667C3.80691 9.99996 2.5 8.69304 2.5 7.08329C2.5 5.47354 3.80691 4.16663 5.41667 4.16663H12.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 4.16663C12.5 5.54641 13.6202 6.66663 15 6.66663C16.3798 6.66663 17.5 5.54641 17.5 4.16663C17.5 2.78684 16.3798 1.66663 15 1.66663C13.6202 1.66663 12.5 2.78684 12.5 4.16663Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgHeroBarChartIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M2.5 2.5V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H17.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 14.1667V7.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8333 14.1666V4.16663"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 14.1666V11.6666"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
